// import { GetAllOrdersByCustomerAction } from "../Slices/Customer/GetAllOrdersByCustomer";
// import { EventGetAllAction } from "../Slices/Events/EventGetAll";

import { bulkUpdateActiveDeactiveEmployeeFromExcelAction } from "../Slices/AddEmployee/bulkUpdateActiveDeactiveEmployeeFromExcel";
import { bulkUpdateEmployeeFromExcelAction } from "../Slices/AddEmployee/bulkUpdateEmployeeFromExcel";
import { bulkUploadEmployeeFromExcelAction } from "../Slices/AddEmployee/bulkUploadEmployeeFromExcel";
import { createEmployeeAction } from "../Slices/AddEmployee/createEmployee";
import { getAllEmployeesAction } from "../Slices/AddEmployee/getAllEmployees";
import { getEmployeeByIdAction } from "../Slices/AddEmployee/getEmployeeById";
import { toggleEmployeeStatusAction } from "../Slices/AddEmployee/toggleEmployeeStatus";
import { updateEmployeeAction } from "../Slices/AddEmployee/updateEmployee";
import { bulkUploadDepartmentsAction } from "../Slices/CreateDepartment/bulkUploadDepartments";
import { createDepartmentAction } from "../Slices/CreateDepartment/createDepartment";
import { downloadAllDepartmentsAction } from "../Slices/CreateDepartment/downloadAllDepartments";
import { getAllDepartmentsAction } from "../Slices/CreateDepartment/getAllDepartments";
import { getDepartmentByIdAction } from "../Slices/CreateDepartment/getDepartmentById";
import { updateDepartmentAction } from "../Slices/CreateDepartment/updateDepartment";
import { getAdminDashboardAction } from "../Slices/Dashboard/getAdminDashboard";
import { getAdminDashboardByYearAction } from "../Slices/Dashboard/getAdminDashboardByYear";
import { getEmployeeDashboardAction } from "../Slices/Dashboard/getEmployeeDashboard";
import { getEmployeeDashboardByYearAction } from "../Slices/Dashboard/getEmployeeDashboardByYear";
import { getSiteSettingsAction } from "../Slices/Dashboard/getSiteSettings";
import { loginAuthUserAction } from "../Slices/Dashboard/loginAuthUser";
import { saveSiteSettingsAction } from "../Slices/Dashboard/saveSiteSettings";
import { bulkUploadDesignationsAction } from "../Slices/Designation/bulkUploadDesignations";
import { createDesignationAction } from "../Slices/Designation/createDesignation";
import { downloadAllDesignationsAction } from "../Slices/Designation/downloadAllDesignations";
import { getAllDesignationsAction } from "../Slices/Designation/getAllDesignations";
import { getDesignationByIdAction } from "../Slices/Designation/getDesignationById";
import { updateDesignationAction } from "../Slices/Designation/updateDesignation";
import { acceptAppraisalReapplyAction } from "../Slices/Employee/acceptAppraisalReapply";
import { createKraKpiAnswerAction } from "../Slices/Employee/createKraKpiAnswer";
import { getAdminReportByAppraisalYearAction } from "../Slices/Employee/getAdminReportByAppraisalYear";
import { getAppraisalYearPmsScoreStatusByYearAction } from "../Slices/Employee/getAppraisalYearPmsScoreStatusByYear";
import { getEmployeeKraKpiStatusListAction } from "../Slices/Employee/getEmployeeKraKpiStatusList";
import { getKraKpiAppraisalFormAction } from "../Slices/Employee/getKraKpiAppraisalForm";
import { getManagersEmployeeKraKpiStatusListAction } from "../Slices/Employee/getManagersEmployeeKraKpiStatusList";
import { getReviewerEmployeeKraKpiStatusListAction } from "../Slices/Employee/getReviewerEmployeeKraKpiStatusList";
import { loginEmployeeAction } from "../Slices/Employee/loginEmployee";
import { pmsScoreShowHideAction } from "../Slices/Employee/pmsScoreShowHide";
import { rejectAppraisalReapplyAction } from "../Slices/Employee/rejectAppraisalReapply";
import { rejectManagerEvaluationAction } from "../Slices/Employee/rejectManagerEvaluation";
import { rejectReviewerEvaluationAction } from "../Slices/Employee/rejectReviewerEvaluation";
import { requestAppraisalReapplyAction } from "../Slices/Employee/requestAppraisalReapply";
// import { rejectReviewerEvaluationAction, updateEmployeeEvaluationAction } from "../Slices/Employee/updateEmployeeEvaluation";
import { submitReviewerEvaluationAction } from "../Slices/Employee/submitReviewerEvaluation";
import { updateEmployeeEvaluationAction } from "../Slices/Employee/updateEmployeeEvaluation";
import { updateManagerEvaluationAction } from "../Slices/Employee/updateManagerEvaluation";
import { getEmployeeByloginAction } from "../Slices/ForgetPassword/getEmployeeBylogin";
import { getEmployeeEmailByCodeAction } from "../Slices/ForgetPassword/getEmployeeEmailByCode";
import { resetPasswordForEmployeeAction } from "../Slices/ForgetPassword/resetPasswordForEmployee";
import { sendOTPAction } from "../Slices/ForgetPassword/sendOTP";
import { verifyOTPAction } from "../Slices/ForgetPassword/verifyOTP";
import { bulkUploadKraKpisAction } from "../Slices/KRA&KPI/bulkUploadKraKpis";
import { createKraKpiAction } from "../Slices/KRA&KPI/createKraKpi";
import { downloadAllKraKpisAction } from "../Slices/KRA&KPI/downloadAllKraKpis";
import { getAllKraKpiAction } from "../Slices/KRA&KPI/getAllKraKpi";
import { getKraKpiByIdAction } from "../Slices/KRA&KPI/getKraKpiById";
import { updateKraKpiAction } from "../Slices/KRA&KPI/updateKraKpi";
import { bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcelAction } from "../Slices/KraKpiQuestions/bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel";
import { bulkUploadKraKpiQuestionsFromExcelAction } from "../Slices/KraKpiQuestions/bulkUploadKraKpiQuestionsFromExcel";
import { createKraKpiQuestionForkrakpiAction } from "../Slices/KraKpiQuestions/createKraKpiQuestionForkrakpi";
import { downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFileAction } from "../Slices/KraKpiQuestions/downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFile";
import { downloadKraKpiQuestionsSampleExcelFileAction } from "../Slices/KraKpiQuestions/downloadKraKpiQuestionsSampleExcelFile";
import { getAllQuestionsAction } from "../Slices/KraKpiQuestions/getAllQuestions";
import { getQuestionByIdAction } from "../Slices/KraKpiQuestions/getQuestionById";
import { updateQuestionAction } from "../Slices/KraKpiQuestions/updateQuestion";
import { getEmailConfigAction } from "../Slices/MailSettings/getEmailConfig";
import { MicrosoftUsersyncAction } from "../Slices/MailSettings/MicrosoftUsersync";
import { testEmailConnectionAction } from "../Slices/MailSettings/testEmailConnection";
import { updateEmailConfigAction } from "../Slices/MailSettings/updateEmailConfig";
import { bulkUploadSubDepartmentsAction } from "../Slices/SubDepartment/bulkUploadSubDepartments";
import { createSubDepartmentAction } from "../Slices/SubDepartment/createSubDepartment";
import { downloadAllSubDepartmentsAction } from "../Slices/SubDepartment/downloadAllSubDepartments";
import { getAllSubDepartmentsAction } from "../Slices/SubDepartment/getAllSubDepartments";
import { getSubDepartmentByIdAction } from "../Slices/SubDepartment/getSubDepartmentById";
import { getSubDepartmentsByDepartmentIdAction } from "../Slices/SubDepartment/getSubDepartmentsByDepartmentId";
import { updateSubDepartmentAction } from "../Slices/SubDepartment/updateSubDepartment";
import { getBellCurveReportByAppraisalYearAction } from "../Slices/UploadFile/getBellCurveReportByAppraisalYear";
import { uploadImageAction } from "../Slices/UploadFile/uploadImage";
import { uploadMultiplePdfsAction } from "../Slices/UploadFile/uploadMultiplePdfs";
import { uploadPdfAndImageAction } from "../Slices/UploadFile/uploadPdfAndImage";
import { createAppraisalYearAction } from "../Slices/YearOfDuration/createAppraisalYear";
import { deletePdfByNameAction } from "../Slices/YearOfDuration/deletePdfByName";
import { downloadPdfByNameAction } from "../Slices/YearOfDuration/downloadPdfByName";
import { getAllAppraisalYearsAction } from "../Slices/YearOfDuration/getAllAppraisalYears";
import { getAppraisalYearByIdAction } from "../Slices/YearOfDuration/getAppraisalYearById";
import { getPdfsByAppraisalYearAction } from "../Slices/YearOfDuration/getPdfsByAppraisalYear";
import { updateAppraisalYearAction } from "../Slices/YearOfDuration/updateAppraisalYear";

const actions = {
  // ...LoginPostAction,

  ...createDepartmentAction,
  ...bulkUploadDepartmentsAction,
  ...downloadAllDepartmentsAction,
  ...getAllDepartmentsAction,
  ...getDepartmentByIdAction,
  ...updateDepartmentAction,

  ...createSubDepartmentAction,
  ...bulkUploadSubDepartmentsAction,
  ...downloadAllSubDepartmentsAction,
  ...getAllSubDepartmentsAction,
  ...getSubDepartmentByIdAction,
  ...updateSubDepartmentAction,

  ...createDesignationAction,
  ...bulkUploadDesignationsAction,
  ...downloadAllDesignationsAction,
  ...getAllDesignationsAction,
  ...getDesignationByIdAction,
  ...updateDesignationAction,

  ...createKraKpiAction,
  ...bulkUploadKraKpisAction,
  ...downloadAllKraKpisAction,
  ...getAllKraKpiAction,
  ...getKraKpiByIdAction,
  ...updateKraKpiAction,

  ...createAppraisalYearAction,
  ...getAllAppraisalYearsAction,
  ...getAppraisalYearByIdAction,
  ...updateAppraisalYearAction,

  ...getSubDepartmentsByDepartmentIdAction,

  ...getAllEmployeesAction,
  ...createEmployeeAction,
  ...getEmployeeByIdAction,
  ...updateEmployeeAction,
  ...toggleEmployeeStatusAction,
  ...createKraKpiQuestionForkrakpiAction,

  ...getAllQuestionsAction,
  ...getQuestionByIdAction,
  ...updateQuestionAction,

  ...getEmployeeKraKpiStatusListAction,

  ...getAdminReportByAppraisalYearAction,
  ...getKraKpiAppraisalFormAction,

  ...createKraKpiAnswerAction,
  ...uploadPdfAndImageAction,

  ...getManagersEmployeeKraKpiStatusListAction,
  ...updateManagerEvaluationAction,

  ...getReviewerEmployeeKraKpiStatusListAction,
  ...rejectManagerEvaluationAction,
  ...rejectReviewerEvaluationAction,
  ...submitReviewerEvaluationAction,

  ...updateEmployeeEvaluationAction,

  ...requestAppraisalReapplyAction,
  ...rejectAppraisalReapplyAction,
  ...acceptAppraisalReapplyAction,
  ...loginEmployeeAction,

  ...bulkUploadEmployeeFromExcelAction,
  ...bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcelAction,
  ...downloadKraKpiAnswersOfManagerAndReviewerEvalutationSampleExcelFileAction,

  ...bulkUploadKraKpiQuestionsFromExcelAction,
  ...downloadKraKpiQuestionsSampleExcelFileAction,

  ...getAdminDashboardAction,
  ...getEmployeeDashboardAction,

  ...loginAuthUserAction,
  ...getBellCurveReportByAppraisalYearAction,

  ...sendOTPAction,
  ...verifyOTPAction,
  ...getEmployeeEmailByCodeAction,
  ...resetPasswordForEmployeeAction,

  ...uploadMultiplePdfsAction,

  ...pmsScoreShowHideAction,

  ...getAdminDashboardByYearAction,

  ...saveSiteSettingsAction,
  ...getSiteSettingsAction,

  ...uploadImageAction,

  ...getEmployeeDashboardByYearAction,

  ...getEmployeeByloginAction,

  ...getPdfsByAppraisalYearAction,
  ...deletePdfByNameAction,
  ...downloadPdfByNameAction,

  ...updateEmailConfigAction,
  ...getEmailConfigAction,
  ...testEmailConnectionAction,
  ...MicrosoftUsersyncAction,

  ...bulkUpdateEmployeeFromExcelAction,
  ...bulkUpdateActiveDeactiveEmployeeFromExcelAction,

  ...getAppraisalYearPmsScoreStatusByYearAction,
};

export default actions;
